<div
	class="file-list-wrapper h-full grid grid-cols-1 grid-rows-[min-content_1fr] overflow-hidden"
	[ngClass]="{
		'h-auto max-h-none bg-white border border-grey-lighter cursor-default rounded-b-lg':
			!!root,
	}"
>
	<!-- headers -->
	<div *ngIf="showHeaders" class="flex headers">
		<div>
			<app-icon
				class="cursor-pointer"
				[icon]="
					documentsExpandAll ? ICON.FOLDER_ARROW_UP : ICON.FOLDER_ARROW_DOWN
				"
				(click)="onExpandAllClick()"
				[matTooltip]="documentsExpandAll ? 'Collapse all' : 'Expand all'"
			></app-icon>
		</div>
		<div
			class="grow sortable"
			(click)="changeSort('title', sortOrder === 'asc' ? 'desc' : 'asc')"
		>
			Name
			<ng-container
				*ngTemplateOutlet="tplSortIcon; context: { targetSort: 'title' }"
			></ng-container>
		</div>
		<div *ngIf="showTypeTags" class="set-width-reduced sortable">
			File Types
		</div>
		<div
			class="set-width-wide sortable"
			(click)="changeSort('lastEditedBy', sortOrder === 'asc' ? 'desc' : 'asc')"
		>
			Last edited by
			<ng-container
				*ngTemplateOutlet="tplSortIcon; context: { targetSort: 'lastEditedBy' }"
			></ng-container>
		</div>
		<div
			class="set-width sortable"
			(click)="changeSort('updatedAt', sortOrder === 'asc' ? 'desc' : 'asc')"
		>
			Last edited on
			<ng-container
				*ngTemplateOutlet="tplSortIcon; context: { targetSort: 'updatedAt' }"
			></ng-container>
		</div>
		<div class="kebab-column">&nbsp;</div>
	</div>

	<!-- folders -->
	<div class="list-body overflow-x-hidden overflow-y-auto">
		<ng-container *ngFor="let folder of filteredFolders; trackBy: trackById">
			<!-- folder row -->
			<div
				class="flex folders file-list clickable"
				(dragover)="onFolderDragOver($event, folder)"
				(dragenter)="onFolderDragEnter($event, folder)"
				(dragleave)="onFolderDragLeave($event, folder)"
				(drop)="onFolderDrop($event, folder)"
				(click)="onFolderClick($event, folder)"
			>
				<!-- name column -->
				<div class="grow flex name-col">
					<app-icon
						class="row-icon"
						[icon]="
							folder.expanded || documentsExpandAll
								? ICON.FOLDER_OPEN
								: ICON.FOLDER
						"
						[iconStyle]="
							folder.expanded || documentsExpandAll
								? ICON_STYLE.REGULAR
								: ICON_STYLE.SOLID
						"
					></app-icon>
					<span class="title" [innerHtml]="folder.title"></span>
					<span class="text-gray-400">&nbsp;&nbsp;({{ folder.children }})</span>
				</div>

				<!-- show types (optional) -->
				<div *ngIf="showTypeTags" class="set-width-reduced">
					<span class="file-type-pill"
						><span
							*ngIf="folder.matterType.includes(MatterFileType.SALE)"
							class="file-type-sale"
							title="Sale"
							>S</span
						></span
					>
					<span class="file-type-pill"
						><span
							*ngIf="folder.matterType.includes(MatterFileType.PURCHASE)"
							class="file-type-purchase"
							title="Purchase"
							>P</span
						></span
					>
					<span class="file-type-pill"
						><span
							*ngIf="folder.matterType.includes(MatterFileType.REFINANCE)"
							class="file-type-refinance"
							title="Refinance"
							>R</span
						></span
					>
				</div>

				<!-- owner -->
				<div class="text-ellipsis overflow-hidden set-width-wide">
					<span *ngIf="authors">{{ authors[folder.author] }}</span>
				</div>

				<!-- last edited -->
				<div class="set-width">{{ folder.updatedAt | date: 'medium' }}</div>

				<!-- hamburger -->
				<atomic-kebab-options
					[itemGroups]="folderItemGroups[folder.id]"
					(onSelect)="onFolderKebabSelect($event.result, folder)"
					(click)="onFolderKebabClick($event)"
				></atomic-kebab-options>
			</div>

			<!-- expanded folder - children  -->
			<div *ngIf="folder.expanded || documentsExpandAll" class="sub-list ml-10">
				<app-document-tree
					(addDocument)="emitAddDocument($event)"
					(addBlankDocument)="emitAddBlankDocument($event)"
					(addDocumentFromTemplate)="emitAddDocumentFromTemplate($event)"
					(addFolder)="emitAddFolder($event)"
					[authors]="authors"
					[canCreateFolder]="canCreateFolder.bind(this)"
					[canMoveDocument]="canMoveDocument.bind(this)"
					[canMoveDocumentToFolder]="canMoveDocumentToFolder.bind(this)"
					(copyDocument)="emitCopyDocument($event)"
					[currentFolderId]="folder.id"
					(deleteDocument)="emitDeleteDocument($event)"
					(deleteFolder)="emitDeleteFolder($event)"
					[documents]="documents"
					(editDocument)="emitEditDocument($event)"
					(editFolder)="emitEditFolder($event)"
					[filter]="filter"
					[folders]="folders"
					[matterType]="matterType"
					[mode]="mode"
					(moveDocument)="emitMoveDocument($event)"
					(moveDocumentsToFolder)="emitMoveDocumentsToFolder($event)"
					[parentId]="parentId ? parentId : folder.id"
					(resetDocument)="emitResetDocument($event)"
					[root]="false"
					(selectedDocuments)="emitSelectedDocuments($event)"
					[showHeaders]="false"
					[showTypeTags]="showTypeTags"
					[showVersions]="showVersions"
					[sortBy]="sortBy"
					[sortOrder]="sortOrder"
				></app-document-tree>
			</div>
		</ng-container>
		<!-- document list -->
		<div
			*ngFor="let document of filteredDocuments; trackBy: trackById"
			class="files flex file-list clickable selectable"
			[class.selected]="documentSelection?.has(document.id)"
			[class.dragging]="documentIdsBeingDragged.has(document.id)"
			draggable="true"
			(dragstart)="onDocumentDragStart($event, document)"
			(dragend)="onDocumentDragEnd()"
			(dragover)="onFileDragOver($event)"
			(drop)="onFileDrop($event, document)"
			(click)="onFileClick($event, document)"
			(dblclick)="onFileDoubleClick($event, document)"
		>
			<!-- name -->
			<div class="grow name-col">
				<app-icon
					class="row-icon"
					[icon]="document.collection?.length ? ICON.COPY : ICON.FILE"
				></app-icon>
				<span class="title">{{ document.title }}</span>
				<span *ngIf="showVersions && document.version" class="text-gray-400"
					>v{{ document.version }}</span
				>
			</div>

			<!-- show types -->
			<div *ngIf="showTypeTags" class="set-width-reduced clickable">
				<span class="file-type-pill"
					><span
						*ngIf="document.matterType.includes(MatterFileType.SALE)"
						class="file-type-sale"
						title="Sale"
						>S</span
					></span
				>
				<span class="file-type-pill"
					><span
						*ngIf="document.matterType.includes(MatterFileType.PURCHASE)"
						class="file-type-purchase"
						title="Purchase"
						>P</span
					></span
				>
				<span class="file-type-pill"
					><span
						*ngIf="document.matterType.includes(MatterFileType.REFINANCE)"
						class="file-type-refinance"
						title="Refinance"
						>R</span
					></span
				>
			</div>

			<!-- owner -->

			<div
				class="text-ellipsis overflow-hidden set-width-wide clickable max-w-100"
			>
				<span *ngIf="authors">
					{{
						mode === DocumentTreeModes.MANAGE
							? authors[document.lastEditedBy] || authors[document.author]
							: authors[document.author]
					}}
				</span>
			</div>

			<!-- updated -->
			<div class="set-width clickable">
				{{ document.updatedAt || null | date: 'medium' }}
			</div>

			<!-- hamburger -->
			<atomic-kebab-options
				(click)="onFileKebabClick($event)"
				[disabled]="isFileSelectorDisabled(document.id)"
				[itemGroups]="fileItemGroups[document.id]"
				(onSelect)="onFileKebabSelect($event.result, document)"
			></atomic-kebab-options>
		</div>
		<div *ngIf="!!root" class="h-12">
			<!-- spacing to account for the intercom icon -->
		</div>
	</div>
	<div
		*ngIf="root && !filteredFolders?.length && !filteredDocuments?.length"
		class="flex flex-auto justify-center p-4 text-grey"
	>
		No matching documents found
	</div>
</div>

<ng-template #tplSortIcon let-targetSort="targetSort">
	<app-icon
		class="ml-2 text-sm"
		*ngIf="sortBy === targetSort"
		[icon]="sortOrder === 'asc' ? ICON.ARROW_DOWN : ICON.ARROW_UP"
	></app-icon>
</ng-template>
